export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_MESSAGE_SEND_STATUS = 'SET_MESSAGE_SEND_STATUS'
export const SET_PARENT_SIZE_INFO = 'SET_PARENT_SIZE_INFO'
export const SET_WIDGET_SETTINGS = 'SET_WIDGET_SETTINGS'
